import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import DoneIcon from '@mui/icons-material/Done';
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom';
import CloseIcon from '@mui/icons-material/Close';
import AsyncSelect from 'react-select/async';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { fetchData, updateData, postData } from '../../../apiService';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Tooltip } from '@material-ui/core';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import SaveAsIcon from '@mui/icons-material/SaveAs';
import Modal from '@mui/material/Modal';
import { FaTimes } from 'react-icons/fa'; // Example for FontAwesome Icon
import AsyncCreatableSelect from 'react-select/async-creatable';
import { useLocation } from 'react-router-dom';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import ReactDOM from 'react-dom';
import BillPrint from '../Sale/Print';
import Select from 'react-select';
import ImportExportIcon from '@mui/icons-material/ImportExport';

const SaleEdit = () => {
    const { id } = useParams(); // Use useParams to get the id from the URL  
    const [selectedItems, setSelectedItems] = useState([]);
    const [orderDetails, setOrderDetails] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    const { isAuthenticated, companyId, branchId, userId, permissions, token, logout, branchstate } = useAuth();
    const [formData, setFormData] = useState({
        BillType: 2, // Default to BtoC        
    });

    const [errorMessage, setErrorMessage] = useState("");
    const history = useHistory();
    const [errorMessageModel, setErrorMessageModel] = useState('');
    const [selectedSalesMan, setSelectedSalesMan] = useState("");
    const [dropdownSalesManOptions, setDropdownSalesManOptions] = useState([]);
    const [defaultFreightGSTRate, setdefaultFreightGSTRate] = useState(0);
    const [defaultPackingGSTRate, setdefaultPackingGSTRate] = useState(0);
    const location = useLocation();


    useEffect(() => {
        // Check if reload is needed based on the flag set in localStorage
        const shouldReload = localStorage.getItem('shouldReloadCreatePage') === 'true';

        if (shouldReload) {
            localStorage.removeItem('shouldReloadCreatePage'); // Remove the flag after use
            window.location.reload(); // Reload the page once
        }

        // Authentication and token expiration handling
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        // Other initializations, if any
    }, [isAuthenticated, companyId, branchId, userId, token, logout]);

    const formatDateForInput = (dateString) => {
        const currentDate = new Date(dateString);;
        const year = currentDate.getFullYear();
        const month = String(currentDate.getMonth() + 1).padStart(2, '0');
        const day = String(currentDate.getDate()).padStart(2, '0');
        const formattedDate = `${year}-${month}-${day}`;

        return formattedDate;
    };


    useEffect(() => {
        fetchInvoicetypeData();
        fetchBranchData();
        fetchDropdownSalesManOptions();
        fetchfrightrate();
    }, []);


    useEffect(() => {
        fetchData('SaleApi', `/${id}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setFormData(response.response_data.Sale);
                    setSelectedItems(response.response_data.SaleDetails);

                    setSelectedOption({
                        value: response.response_data?.Sale?.MasterId ?? 1, // Fallback to 1 if null
                        label: response.response_data?.Sale?.CustomerName ?? '' // Fallback to 'B To B' if null
                    });

                }
            })
            .catch((error) => {
                console.error('Error fetching Sale Details:', error);
            });
    }, [id]);

    const fetchfrightrate = () => {
        fetchData('CompanyApi', `/${companyId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    FreightGSTRate: data[0].FreightGSTRate,
                    PackingGSTRate: data[0].PackingGSTRate,
                }));
                setdefaultFreightGSTRate(data[0].FreightGSTRate);
                setdefaultPackingGSTRate(data[0].PackingGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching options:', error);
            });
    };


    const fetchBranchData = () => {
        fetchData('BranchApi', `/BranchDetails/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    DispatchFrom: data.CompanyName,
                    DispatchAddress1: data.AddressLine1,
                    DispatchAddress2: data.AddressLine2,
                    DispatchLocation: data.Location,
                    DispatchPincode: data.PinCode,

                    TransporterName: data.TransporterName,
                    TransporterGST: data.GSTNumber,
                }));

            })
            .catch((error) => {
                console.error('Error Dispatch Deatils', error);
            });
    };

    const fetchmaxbillno = (invtype) => {

        if (!invtype || invtype === 0) {
            console.error('Error: Please select or type a valid customer.');
            alert('Please select or type a valid customer.');
            return; // Stop function execution
        }

        const customerid = formData.MasterId !== null ? formData.MasterId : 0;

        fetchData('SaleApi', `/MaxBillno/${companyId}/${branchId}/${invtype}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillNumber: data.BillNumber,
                    BillDate: formattedDate,
                    LUTDate: formattedDate,
                    FinYear: data.FinYear,
                    BranchId: branchId,
                    CompanyId: companyId,
                    FreightGSTRate: data.FreightGSTRate,
                    PackingGSTRate: data.PackingGSTRate,
                    BillPrefix: data.BillPrefix,
                }));

                setdefaultFreightGSTRate(data.FreightGSTRate);
                setdefaultPackingGSTRate(data.PackingGSTRate);
            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });


    };

    const fetchLedgerbal = (customerid) => {

        fetchData('SaleApi', `/LedgerBalance/${companyId}/${branchId}/${customerid}`, token)
            .then((response) => response.response_data)
            .then((data) => {

                setFormData(prevData => ({
                    ...prevData,
                    CustomerLedgerAmount: data[0].Amount,
                }));

            })
            .catch((error) => {
                console.error('Error fetching Max Billno', error);
            });
    };

    //FOR GET InvoicetypeData  Details FROM API
    const fetchInvoicetypeData = () => {
        fetchData('SaleApi', `/InvoiceType/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownInvoiceTypeOptions(data);

                const currentDate = new Date();
                const year = currentDate.getFullYear();
                const month = String(currentDate.getMonth() + 1).padStart(2, '0');
                const day = String(currentDate.getDate()).padStart(2, '0');
                const formattedDate = `${year}-${month}-${day}`;

                setFormData(prevData => ({
                    ...prevData,
                    BillDate: formattedDate,
                    LUTDate: formattedDate,
                    BranchId: branchId,
                    CompanyId: companyId,
                    CreatedBy: userId,
                }));
            })
            .catch((error) => {
                console.error('Error fetching Disc Type dropdown options:', error);
            });
    };

    const fetchDropdownSalesManOptions = () => {
        fetchData('SaleApi', `/SalesMan/${companyId}/${branchId}`, token)
            .then((response) => response.response_data)
            .then((data) => {
                setDropdownSalesManOptions(data);
            })
            .catch((error) => {
                console.error('Error fetching Sales Man dropdown options:', error);
            });
    };

    const [supplierOptions, setSupplierOptions] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);
    const [selectedInvoiceType, setSelectedInvoiceType] = useState(null);
    const [dropdownInvoiceTypeOptions, setDropdownInvoiceTypeOptions] = useState([]);
    const handleInputChange = (newValue) => newValue;

    const fetchOptions = async (inputValue) => {
        if (inputValue.length <= 2) {
            return [];
        }


        try {
            const response = await fetchData('SaleApi', `/Customer/${companyId}/${branchId}/${inputValue}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;

                if (Array.isArray(data)) {
                    setSupplierOptions(data); // Save the options for later use
                    return data.map(item => ({
                        value: item.Id,
                        label: item.Name,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching options:', error);
            return [];
        }
    };

    const handleCustomerSelect = (selectedOption) => {
        setSelectedOption(selectedOption);
        setFormData((prevData) => ({
            ...prevData,
            MasterId: selectedOption ? selectedOption.value : '',
            CreatedBy: userId,
        }));

        if (!selectedOption) return;

        const selectedItemId = selectedOption.value;
        const selectedSupplierRetail = supplierOptions.find((itemDetail) => itemDetail.Id === selectedItemId);
        const suppliergstno = selectedSupplierRetail?.TaxNumber ?? '';
        const supplieraddress1 = (selectedSupplierRetail?.AddressLine1 ?? '');
        const supplieraddress2 = (selectedSupplierRetail?.AddressLine2 ?? '');
        const deliveryAddressLine1 = (selectedSupplierRetail?.DeliveryAddressLine1 ?? '');
        const deliveryAddressLine2 = (selectedSupplierRetail?.DeliveryAddressLine2 ?? '');
        const suppliercontactno = selectedSupplierRetail?.ContactNumber1 ?? '';
        const supplierlocation = selectedSupplierRetail?.Location ?? '';
        const supplierpincode = selectedSupplierRetail?.PinCode ?? '';
        const supplierName = selectedSupplierRetail?.Name ?? '';

        let gstNumber = '';

        if (!suppliergstno) {
            gstNumber = '';
        } else {
            gstNumber = suppliergstno;
        }

        const InvoiceTypeId = selectedSupplierRetail?.InvoiceTypeId ?? '';
        const InvoiceTypeName = selectedSupplierRetail?.InvoiceTypeName ?? '';

        setSelectedInvoiceType({
            value: InvoiceTypeId,
            label: InvoiceTypeName,
        });

        setFormData((prevData) => ({
            ...prevData,
            InvoiceTypeId: InvoiceTypeId,
            InvoiceTypeName: InvoiceTypeName,
            TaxNumber: gstNumber,
            CustomerAddress: supplieraddress1 + ' ' + supplieraddress2,
            ContactNumber: suppliercontactno,
            CustomerName: supplierName,
            CreatedBy: userId,
        }));
        fetchmaxbillno(InvoiceTypeId);
        fetchLedgerbal(selectedOption ? selectedOption.value : '',);
    };

    // Helper function to parse and handle NaN values as 0
    const parseAndFix = (val) => parseFloat(val) || 0;

    const calculateItemData = (item, formData) => {
        //let rate = parseAndFix(item.Rate);
        let rate;
        if (formData.BillType === 1) {
            rate = parseFloat(item.WholesaleRate) || 0;
        } else if (formData.BillType === 2) {
            rate = parseFloat(item.RetailRate) || 0;
        } else if (formData.BillType === 3) {
            rate = parseFloat(item.BtoCRate) || 0;
        }
        let quantity = parseAndFix(item.Quantity);
        let taxRate = parseAndFix(item.TaxRate);

        let Discper = parseAndFix(item.DiscountPercentage);
        let Addidiscamt = ((rate * Discper) / 100).toFixed(2)
        let totdiscount = parseFloat(Addidiscamt);
        let grate = (rate - totdiscount).toFixed(2);
        let amt = (quantity * rate).toFixed(2);

        let salerate = ((grate * quantity)).toFixed(2);
        const taxableamount = salerate;

        let amount = taxableamount;
        let taxAmount = 0;

        taxAmount = ((amount * taxRate) / 100).toFixed(2);

        let defaultFreightGST = Math.max(defaultFreightGSTRate, item.GSTRate);
        let defaultPackingGST = Math.max(defaultPackingGSTRate, item.GSTRate);
        setdefaultFreightGSTRate(defaultFreightGST);
        setdefaultPackingGSTRate(defaultPackingGST);

        const totalAmount = parseAndFix(amount) + parseAndFix(taxAmount);

        return {
            ...item,
            Rate: rate,
            Amount: amt,
            DiscountAmount: parseAndFix(totdiscount * quantity).toFixed(2),
            TaxableAmount: amount,
            TaxAmount: taxAmount,
            TotalAmount: totalAmount.toFixed(2),

        };
    };

    const totalCalculation = (Quantity, Amount, DiscountAmount, TaxableAmount, TaxAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount) => {

        let freightGSTRate = parseAndFix(formData.FreightGSTRate);
        let packingGSTRate = parseAndFix(formData.PackingGSTRate);
        if (formData.InvoiceTypeId == 4) {
            freightGSTRate = 0;
            packingGSTRate = 0;
        }
        else {
            freightGSTRate = Math.max(freightGSTRate, parseAndFix(defaultFreightGSTRate));
            packingGSTRate = Math.max(packingGSTRate, parseAndFix(defaultFreightGSTRate));
        }
        let freightGSTAmount = ((FreightAmount * freightGSTRate) / 100).toFixed(2);
        let packingGSTAmount = ((PackingAmount * packingGSTRate) / 100).toFixed(2);

        let netAmount = parseAndFix(TaxableAmount) + parseAndFix(TaxAmount) + parseAndFix(FreightAmount) + parseAndFix(PackingAmount) + parseAndFix(freightGSTAmount) + parseAndFix(packingGSTAmount) + parseAndFix(TCSAmount);
        let roundOff = Math.round(netAmount) - netAmount;
        let grandTotal = netAmount + roundOff;
        let balhamt = parseFloat(grandTotal - (parseAndFix(CashAmount) + parseAndFix(CardAmount) + parseAndFix(UPIAmount)));

        setFormData((prev) => ({
            ...prev,
            TotalQuantity: Quantity,
            TotalAmount: Amount.toFixed(2),
            TaxableAmount: TaxableAmount.toFixed(2),
            TaxAmount: TaxAmount.toFixed(2),
            RoundOff: roundOff.toFixed(2),
            GrandTotal: grandTotal.toFixed(2),
            BalanceAmount: balhamt.toFixed(2),
            DiscountAmount: DiscountAmount.toFixed(2),
            FreightGSTAmount: freightGSTAmount,
            PackingGSTAmount: packingGSTAmount,
            ModifiedBy: userId,
            FreightGSTRate: freightGSTRate,
            PackingGSTRate: packingGSTRate,
        }));
    };

    // Calculation
    const handleCalculation = (e, index, inputType) => {
        let name, value;
        if (typeof e === 'object') {
            name = e.target.name;
            value = e.target.value;
        } else {
            name = inputType;
            value = e;
        }

        // Assuming selectedItems is a state setter function (e.g., setSelectedItems)
        setSelectedItems((prevDetails) => {

            const updatedDetails = [...prevDetails];
            const currentItem = { ...updatedDetails[index], [name]: value };

            // Update the item in the copied array
            updatedDetails[index] = currentItem;

            const updatedItemData = updatedDetails.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.TaxAmount += parseAndFix(item.TaxAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, TaxAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.TaxAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );

            return updatedItemData;
        });
    };

    const handleChange = (event) => {
        const { name, value, type, checked } = event.target;

        // Immediate update of the input field
        let updatedValue = type === 'checkbox' ? checked : value === "" ? "0" : value;

        // Validation and adjustment for CardAmount, UPIAmount, and CashAmount
        if (['CardAmount', 'UPIAmount', 'CashAmount'].includes(name)) {
            const grandTotal = parseFloat(formData.GrandTotal || 0);
            const otherAmounts = {
                CardAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0),
                UPIAmount: parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0),
                CashAmount: parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0),
            };

            // Calculate the maximum allowed value for the current field
            const maxAllowed = grandTotal - otherAmounts[name];

            // Ensure the entered value does not exceed the maxAllowed
            updatedValue = Math.min(parseFloat(updatedValue || 0), maxAllowed);
        }

        setFormData((prevData) => ({
            ...prevData,
            [name]: name === "BillType" ? parseInt(value, 10) : updatedValue,
        }));

        if (['FreightAmount', 'PackingAmount', 'TCSAmount', 'CashAmount', 'CardAmount', 'UPIAmount', 'BillType'].includes(name)) {
            // Use the value directly for the calculation to avoid relying on stale state
            updateFormDataAndDetails(name, updatedValue);
        }
    };

    const updateFormDataAndDetails = (key, value) => {
        const fixedValue = parseAndFix(value).toFixed(2);

        // Update the formData with the new value
        setFormData((prevData) => ({
            ...prevData,
            [key]: fixedValue,
            ModifiedBy: userId,
            BillType: key === "BillType" ? parseInt(value, 10) : prevData.BillType, // Update BillType if key is BillType
        }));

        // Use the updated value for calculations
        const updatedFormData = {
            ...formData,    // current form data
            [key]: fixedValue,  // the newly updated value
            BillType: key === "BillType" ? parseInt(value, 10) : formData.BillType, // Update BillType if key is BillType
        };

        // Recalculate invoice details using the latest form data
        const updatedItemData = selectedItems.map((item) => calculateItemData(item, updatedFormData));
        setSelectedItems(updatedItemData);

        // Calculate totals based on the updated invoice details
        const totals = calculateTotals(updatedItemData);

        // Dynamically get the values from the updated form data
        const dynamicValue = (key) => parseAndFix(updatedFormData[key] || 0);

        // Fetch the latest values for calculations               
        const TCSAmount = dynamicValue('TCSAmount');
        const FreightAmount = dynamicValue('FreightAmount');
        const PackingAmount = dynamicValue('PackingAmount');
        let CashAmount = dynamicValue('CashAmount');
        let CardAmount = dynamicValue('CardAmount');
        let UPIAmount = dynamicValue('UPIAmount');
        // Perform the final total calculation
        totalCalculation(
            totals.Quantity,
            totals.Amount,
            totals.DiscountAmount,
            totals.TaxableAmount,
            totals.TaxAmount,
            totals.TotalAmount,
            FreightAmount,
            PackingAmount,
            TCSAmount,
            CashAmount,
            CardAmount,
            UPIAmount,
        );
    };

    // Utility function to calculate totals
    const calculateTotals = (updatedItemData) => {
        return updatedItemData.reduce(
            (acc, item) => {
                acc.Quantity += parseAndFix(item.Quantity);
                acc.Amount += parseAndFix(item.Amount);
                acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                acc.TaxAmount += parseAndFix(item.TaxAmount);
                acc.TotalAmount += parseAndFix(item.TotalAmount);
                return acc;
            },
            { Quantity: 0, Amount: 0, TaxableAmount: 0, DiscountAmount: 0, TaxAmount: 0, TotalAmount: 0, CESSAmount: 0 }
        );
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        setIsLoading(true);


        if (!formData.MasterId) {
            setErrorMessage('Customer is required !');
            setIsLoading(false);
            return;
        }

        setFormData(prevData => ({
            ...prevData,
            CreatedBy: userId,
            BranchId: branchId,
            CompanyId: companyId,
        }));

        const CreateData = {
            Sale: formData,
            SaleDetails: selectedItems
        };

        // Validate form data here if needed

        updateData('SaleApi', `${id}`, CreateData, token)
            .then((response) => {
                console.log('Record updated successfully:', response.data);
                const SaleId = response.kotId;
                handlePrint(SaleId);
                history.push('/SaleIndex');
            })
            .catch((error) => {
                console.error('Error updating record:', error);
            });
    };

    const handlePrint = async (saleid) => {
        try {

            const response = await fetchData('SaleApi', `/SalePrint/${saleid}/${branchId}`, token);
            const labelData = response.response_data;
            const labelsToPrint = Array.isArray(labelData) ? labelData : [labelData];

            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();
            // iframe.contentWindow.print();
            setTimeout(() => {
                iframe.contentWindow.print();
            }, 1000);

        } catch (error) {
            console.error('Error printing Invoice:', error);
        }
    };

    //handle search [ITEM SEARCH]
    const [isFocused, setIsFocused] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    //search
    const filteredData = selectedItems.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [itemToDeleteIndex, setItemToDeleteIndex] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

    const openConfirmDialog = (index) => {
        setItemToDeleteIndex(index);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setConfirmDialogOpen(false);
        setItemToDeleteIndex(null);
    };

    const handleDelete = () => {
        if (itemToDeleteIndex !== null) {
            const updatedItemList = selectedItems.filter((_, i) => i !== itemToDeleteIndex);
            setSelectedItems(updatedItemList);

            const updatedItemData = updatedItemList.map((item) => calculateItemData(item, formData));

            const totals = updatedItemData.reduce(
                (acc, item) => {
                    acc.Quantity += parseAndFix(item.Quantity);
                    acc.Amount += parseAndFix(item.Amount);
                    acc.DiscountAmount += parseAndFix(item.DiscountAmount);
                    acc.TaxableAmount += parseAndFix(item.TaxableAmount);
                    acc.TaxAmount += parseAndFix(item.TaxAmount);
                    acc.TotalAmount += parseAndFix(item.TotalAmount);

                    return acc;
                },
                { Quantity: 0, Amount: 0, DiscountAmount: 0, TaxableAmount: 0, TaxAmount: 0, TotalAmount: 0 }
            );

            const FreightAmount = parseAndFix(formData.FreightAmount);
            const PackingAmount = parseAndFix(formData.PackingAmount);
            const TCSAmount = parseAndFix(formData.TCSAmount);
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;

            totalCalculation(
                totals.Quantity,
                totals.Amount,
                totals.DiscountAmount,
                totals.TaxableAmount,
                totals.TaxAmount,
                totals.TotalAmount,
                FreightAmount,
                PackingAmount,
                TCSAmount,
                CashAmount,
                CardAmount,
                UPIAmount,
            );


            closeConfirmDialog();
        }
    };

    // For Item
    const [itemsOptions, setItemsrOptions] = useState([]);
    const handleItemChange = (newValue) => newValue;
    const fetchItemOptions = async (inputValue = '') => {
        // Early return if input value is empty or too short
        if (!inputValue || inputValue.length <= 1) {
            return [];
        }

        const customerid = formData.MasterId !== null ? formData.MasterId : 0;

        try {
            // Fetch data from the API
            // const response = await fetchData('SaleApi', `/Item/${companyId}/${branchId}/${customerid}/${inputValue}`, token);
            const response = await fetchData('PurchaseOrderApi', `/Item/${companyId}/${branchId}/${inputValue}`, token);

            // Check if the response code is 1111
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                setItemsrOptions(data); // Save the options for later use
                // Ensure the response data is an array
                if (Array.isArray(data)) {

                    return data.map(item => ({
                        value: item.Id,
                        label: item.ItemName1,
                    }));
                } else {
                    console.error('Data is not an array:', data);
                    return [];
                }
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching item options:', error);
            return [];
        }
    };

    const handleChangeDrop = (selectedOption) => {
        setSelectedItemOption(selectedOption);
        const selectedItemId = selectedOption ? selectedOption.value : '';
        fetchBatchOptions(selectedItemId);
    };

    // For Batch
    const [batchOptions, setBatchOptions] = useState([]);
    const handleBatchChange = (newValue) => newValue;
    const [selectedBatchOption, setSelectedBatchOption] = useState(null);
    const fetchBatchOptions = async (itemId) => {
        try {
            const customerid = 0;
            const response = await fetchData('SaleApi', `/Batch/${companyId}/${branchId}/${customerid}/${itemId}`, token);
            if (response.responseCode === '1111') {
                const data = await response.response_data;
                setBatchOptions(data); // Save the options for later use
                return data.map(item => ({
                    value: item.StockId,
                    label: item.BatchNumber + ',Exp.Date:' + (item.ExpirydDate ? ' - ' + formatDateForInput(item.ExpirydDate) : ''),
                }));
            } else {
                console.error('Unexpected response code:', response.responseCode);
                return [];
            }
        } catch (error) {
            console.error('Error fetching batch options:', error);
            return [];
        }
    };

    const handleChangeBatch = (selectedOption) => {
        setSelectedBatchOption(selectedOption);
        const selectedItemId = selectedOption ? selectedOption.value : '';
    };

    const handleModalInputChange = (event) => {
        const { name, value } = event.target;
        setModalData((prevData) => ({
            ...prevData,
            [name]: value,
        }));

        if (name === 'Quantity') {

            const quantity = parseFloat(value) || 0;
            //const rate = parseFloat(modalData.Rate) || '';
            let rate;
            if (formData.BillType === 1) {
                rate = parseFloat(modalData.WholesaleRate) || 0;
            } else if (formData.BillType === 2) {
                rate = parseFloat(modalData.RetailRate) || 0;
            } else if (formData.BillType === 3) {
                rate = parseFloat(modalData.BtoCRate) || 0;
            }
            let taxrate = modalData.TaxRate;

            const amt = (quantity * rate).toFixed(2);
            let salerate = ((rate * modalData.Quantity)).toFixed(2);//((rate * modalData.Quantity) / (1 + (cgstrate + sgstrate) / 100)).toFixed(2);
            const taxableamount = salerate;
            let amount = taxableamount;

            let taxAmount = 0;

            taxAmount = ((amount * (taxrate)) / 100).toFixed(2);


            const totalAmount = (parseFloat(amount) + parseFloat(taxAmount)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, modalData.GSTRate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, modalData.GSTRate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                // Rate: rate.toFixed(2),
                Rate: rate,
                Quantity: quantity,
                Amount: amt,
                TaxableAmount: amount,
                TaxAmount: taxAmount,
                TotalAmount: totalAmount,

            });
        }
        else if (name === 'Rate') {
            const quantity = parseFloat(modalData.Quantity) || 0;
            const rate = parseFloat(value) || 0;
            let taxrate = modalData.TaxRate;
            const amt = (quantity * rate).toFixed(2);
            let salerate = ((rate * modalData.Quantity)).toFixed(2);//((rate * modalData.Quantity) / (1 + (cgstrate + sgstrate) / 100)).toFixed(2);
            const taxableamount = salerate;
            let amount = taxableamount;

            let taxamt = 0;
            taxamt = ((amount * (taxrate)) / 100).toFixed(2);

            const totalAmount = (parseFloat(amount) + parseFloat(taxamt)).toFixed(2);

            let defaultFreightGST = Math.max(defaultFreightGSTRate, modalData.GSTRate);
            let defaultPackingGST = Math.max(defaultPackingGSTRate, modalData.GSTRate);
            setdefaultFreightGSTRate(defaultFreightGST);
            setdefaultPackingGSTRate(defaultPackingGST);

            setModalData({
                ...modalData,
                Rate: rate,//rate.toFixed(2), // Assuming Rate is a number    
                Quantity: quantity,
                Amount: amt,
                TaxableAmount: amount,
                TaxAmount: taxamt,
                TotalAmount: totalAmount,

            });

        }

    };

    //// modalData 
    // FOR MODEL DATA (Invoice Details)
    const [selectedItemOption, setSelectedItemOption] = useState(null);

    const [modalData, setModalData] = useState({
        SlNo: '0',
        ItemName: '',
        ItemName1: '',
        ItemId: '',
        Quantity: '',
        Rate: '',
        Amount: '',
        TaxableAmount: '',
        TaxRate: '',
        TaxAmount: '',
        TotalAmount: '',
        BalanceStock: '0',
        WholesaleRate: '0',
        RetailRate: '0',
        BtoCRate: '0',
        StockId: '',
        NetWeight: '0',
        GrossWeight: '0',
    });

    const closeModal = () => {
        setModalData({
            SlNo: '0',
            ItemName: '',
            ItemName1: '',
            ItemId: '',
            Quantity: '',
            Rate: '',
            Amount: '',
            TaxRate: '',
            TaxAmount: '',
            TotalAmount: '',
            BalanceStock: '0',
            WholesaleRate: '0',
            RetailRate: '0',
            BtoCRate: '0',
            BatchNumber: '',
            NetWeight: '0',
            GrossWeight: '0',
        });
    };

    const saveModalData = () => {
        let isValid = true;
        let errors = "";
        setErrorMessageModel(errors);

        // Validation for ItemId
        if (!modalData.ItemId) {
            isValid = false;
            errors = "Item is required";
        }

        // Validation for Quantity
        if (!modalData.Quantity || isNaN(modalData.Quantity)) {
            isValid = false;
            errors = "Quantity must be a valid number";
        }



        if (isValid) {
            //setInvoicedeatils([...invoicedeatils, modalData]);

            let rate;
            if (formData.BillType === 1) {
                rate = parseFloat(modalData.WholesaleRate) || 0;
            } else if (formData.BillType === 2) {
                rate = parseFloat(modalData.RetailRate) || 0;
            } else if (formData.BillType === 3) {
                rate = parseFloat(modalData.BtoCRate) || 0;
            }

            let taxrate = modalData.TaxRate;

            const amt = (modalData.Quantity * rate).toFixed(2);

            let salerate = ((rate * modalData.Quantity)).toFixed(2);//((rate * modalData.Quantity) / (1 + (cgstrate + sgstrate) / 100)).toFixed(2);
            const taxableamount = salerate;
            let amount = taxableamount;

            let taxAmount = ((amount * (taxrate)) / 100).toFixed(2);;

            const totalAmount = (parseFloat(amount) + parseFloat(taxAmount)).toFixed(2);

            const newItem = {
                ...modalData,
                Rate: rate,
                Amount: amt,
                TaxableAmount: amount,
                TaxAmount: taxAmount,
                TotalAmount: totalAmount,
            };


            const updatedInvoicedetails = [...selectedItems, newItem];
            const updatedInvoicedetailsSorted = updatedInvoicedetails.reverse();
            setSelectedItems(updatedInvoicedetailsSorted);

            setModalData({
                ...modalData,
                SlNo: '0',
                ItemName: '',
                ItemName1: '',
                ItemId: '',
                Quantity: '',
                Rate: '',
                Amount: '',
                TaxRate: '',
                TaxAmount: '',
                TotalAmount: '',
                BalanceStock: '0',
                BatchNumber: '',
                WholesaleRate: '0',
                RetailRate: '0',
                BtoCRate: '0',
                NetWeight: '0',
                GrossWeight: '0',
            });

            setSelectedItemOption(null); // Clear AsyncSelect
            fetchItemOptions('');

            setSelectedBatchOption(null);
            setBatchOptions(null);

            //closeModal();

            //Update the totals based on the updatedItemData
            const Quantity = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Quantity), 0);
            const Amount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.Amount), 0);
            const TaxAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxAmount), 0);
            const TotalAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TotalAmount), 0);
            const TaxableAmount = updatedInvoicedetails.reduce((sum, item) => sum + parseFloat(item.TaxableAmount), 0);


            let FreightAmount = parseFloat(formData.FreightAmount) || 0;
            let PackingAmount = parseFloat(formData.PackingAmount) || 0;
            let TCSAmount = parseFloat(formData.TCSAmount) || 0;
            let DiscountAmount = parseFloat(formData.DiscountAmount) || 0;
            let CashAmount = parseAndFix(formData.CashAmount) || 0;
            let CardAmount = parseAndFix(formData.CardAmount) || 0;
            let UPIAmount = parseAndFix(formData.UPIAmount) || 0;


            totalCalculation(Quantity, Amount, DiscountAmount, TaxableAmount, TaxAmount, TotalAmount, FreightAmount, PackingAmount, TCSAmount, CashAmount, CardAmount, UPIAmount);
        } else {

            console.log("Validation errors:", errors);
            // setErrorMessageModel(errors);
        }

    };

    const [showModal, setShowModal] = useState(false);

    const opendatamodal = () => {
        setShowModal(true);
    };

    const closeDataModal = () => {
        console.log('Closing modal');
        setShowModal(false);
    };


    return (
        <div className="w-full max-w-sm container mt-6 mx-auto" style={{ minWidth: '100%', marginTop: '-10px' }}>

            <div className="flex flex-wrap justify-between items-center mb-4">
                <h6
                    className="uppercase tracking-wide text-black font-serif flex-grow"
                    style={{
                        fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif',
                        color: 'black',
                        marginTop: '10px',
                    }}
                >
                    Sale Edit
                </h6>
                <Modal open={confirmDialogOpen} onClose={closeConfirmDialog} style={{ marginTop: '10%' }}>
                    <div style={{ padding: '20px', backgroundColor: 'white', borderRadius: '8px', margin: 'auto', width: '30%', textAlign: 'center' }}>
                        <h5>Confirm Delete</h5>
                        <p>Are you sure you want to delete this item? 🤕</p>
                        <Button style={{ margin: '8px', color: 'red' }} onClick={handleDelete}>Delete</Button>
                        <Button style={{ margin: '8px', color: 'grey' }} onClick={closeConfirmDialog}>Cancel</Button>
                    </div>
                </Modal>
                <div
                    className="flex items-center w-full sm:w-auto sm:ml-4"
                    style={{ marginRight: '120px', marginTop: '20px' }}
                >
                    <label
                        className="uppercase block tracking-wide font-bold mr-2"
                        style={{
                            color: 'green',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                            border: '0px solid green',
                            borderRadius: '5px',
                        }}
                    >
                        <input
                            type="radio"
                            name="BillType"
                            value="1"
                            checked={formData.BillType === 1}
                            onChange={handleChange}
                            style={{
                                marginRight: '5px',
                                width: '16px',
                                height: '16px',
                                cursor: 'pointer',
                            }}
                        />
                        Wholesale
                    </label>
                    <label
                        className="uppercase block tracking-wide font-bold mr-2"
                        style={{
                            color: 'blue',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                            border: '0px solid blue',
                            borderRadius: '5px',
                        }}
                    >
                        <input
                            type="radio"
                            name="BillType"
                            value="2"
                            checked={formData.BillType === 2}
                            onChange={handleChange}
                            style={{
                                marginRight: '5px',
                                width: '16px',
                                height: '16px',
                                cursor: 'pointer',
                            }}
                        />
                        Retail
                    </label>
                    <label
                        className="uppercase block tracking-wide font-bold"
                        style={{
                            color: 'brown',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px',
                            padding: '8px',
                            border: '0px solid brown',
                            borderRadius: '5px',
                        }}
                    >
                        <input
                            type="radio"
                            name="BillType"
                            value="3"
                            checked={formData.BillType === 3}
                            onChange={handleChange}
                            style={{
                                marginRight: '5px',
                                width: '16px',
                                height: '16px',
                                cursor: 'pointer',
                            }}
                        />
                        BtoC
                    </label>
                </div>


                <div className="flex items-center w-full sm:w-auto sm:ml-4" style={{ marginRight: '120px', marginTop: '20px' }}>
                    <div className="mr-4">
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="billDate" style={{ fontSize: '12px' }}>
                            Item Count :
                            <span style={{ color: '#F2613F', fontSize: '14px', marginLeft: '4px' }}>
                                {selectedItems.length}
                            </span>
                        </label>
                    </div>

                    <div>
                        <label className="uppercase tracking-wide text-black text-xs font-bold" htmlFor="totalQuantity" style={{ fontSize: '12px' }}>
                            Total QTY :
                            <span style={{ color: 'green', fontSize: '14px', marginLeft: '4px' }}>
                                {formData.TotalQuantity}
                            </span>
                        </label>
                    </div>
                </div>

                <div className="flex mt-8 w-full sm:w-auto">

                    <Button
                        // style={{ marginLeft: '8px', color: 'darkgreen' }}
                        style={{
                            background: 'linear-gradient(to right, #C7FFD8,#C7FFD8)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            //marginLeft: '5px',
                            marginLeft: '15px',

                        }}
                        onClick={handleSubmit}
                        disabled={isLoading}
                    >
                        <DoneIcon style={{ color: 'darkgreen', fontWeight: 'bolder' }} />
                        {isLoading ? <CircularProgress size={24} color="inherit" /> : <b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Save</b>}
                    </Button>

                    <Button
                        color="error"
                        component={Link}
                        to={{
                            pathname: "/SaleIndex",
                            state: { from: "/SaleCreate" },
                        }}
                        onClick={() => {
                            localStorage.setItem('shouldReload', 'true');
                        }}
                        className="linkcolor"
                        // style={{ marginLeft: '8px', color: 'darkred', fontWeight: 'bolder' }}
                        style={{
                            background: 'linear-gradient(to right, #FFAAAA,#FFAAAA)',
                            color: 'black',
                            fontWeight: 'bolder',
                            textTransform: 'none',
                            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                            maxHeight: '30px',
                            //marginLeft: '5px',
                            marginLeft: '15px',

                        }}
                    >
                        <CloseIcon style={{ color: '#A91D3A', fontWeight: 'bolder' }} /><b style={{ fontWeight: 'normal', marginLeft: '5PX' }}>Cancel</b>
                    </Button>
                </div>
            </div>

            {errorMessage && <p className="text-red-500">{errorMessage}</p>}
            <div className="w-full flex flex-wrap" style={{ backgroundColor: 'rgba(201, 222, 219, 0.5)', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full pr-4" style={{ marginTop: '-0.21%' }}>
                    <div className="w-full mb-2 flex">

                        <div className="w-4/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="supplierName">
                                Customer Name
                                <span className="text-red-500">*</span>
                            </label>
                            <AsyncCreatableSelect
                                cacheOptions
                                loadOptions={fetchOptions}
                                onInputChange={handleInputChange}
                                onChange={handleCustomerSelect}
                                value={selectedOption}
                                placeholder="Type or select a customer"
                                formatCreateLabel={(inputValue) => `Add "${inputValue}"`}
                                isClearable
                                onCreateOption={(inputValue) => {
                                    const newOption = { value: inputValue, label: inputValue };
                                    setSupplierOptions([...supplierOptions, newOption]);
                                    setSelectedOption(newOption);
                                    setFormData((prevData) => ({
                                        ...prevData,
                                        MasterId: 0,
                                        CreatedBy: userId,
                                        CustomerName: inputValue,
                                        CustomerAddress: '',
                                        GSTNumber: '',
                                        ContactNumber: '',
                                        InvoiceTypeId: 2,
                                        InvoiceTypeName: 'B To C',
                                        CustomerLedgerAmount: 0,
                                    }));
                                    const newInvoiceTypeId = 2;
                                    setSelectedInvoiceType({
                                        value: 2,
                                        label: 'B To C'
                                    });
                                    fetchmaxbillno(newInvoiceTypeId);
                                }}

                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',         // Adjust height
                                        minHeight: '35px',      // Ensure it doesn't shrink below this
                                        fontSize: '14px',       // Adjust font size
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '14px',       // Adjust font size for input text
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '14px',       // Adjust font size for selected value
                                    }),
                                }}

                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Invoice Type
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formData.InvoiceTypeName}
                                type="text"
                                placeholder="InvoiceTypeName"
                                name='InvoiceTypeName'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>


                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billDate">
                                Sale Date
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={formatDateForInput(formData.BillDate)}
                                onChange={handleChange}
                                type="date"
                                name='BillDate'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                Sale Number
                                <span className="text-red-500">*</span>
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                value={`${formData.BillPrefix || ''}/${formData.BillNumber || ''}/${formData.FinYear || ''}`}
                                onChange={handleChange}
                                type="text"
                                placeholder="Bill Number"
                                name='BillNumber'
                                readOnly
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">
                                Sales Man
                                <span className="text-red-500">*</span>
                            </label>
                            <select
                                className={`custom-select ${selectedSalesMan ? 'fade-in' : 'fade-in'}`}
                                value={selectedSalesMan}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setSelectedSalesMan(selectedValue);
                                    setFormData((prevFormData) => ({
                                        ...prevFormData,
                                        SalesManId: selectedValue,
                                    }));
                                }}

                                style={{
                                    height: '35px',        // Adjust height
                                    fontSize: '14px',      // Adjust font size
                                }}
                            >
                                <option value="">Sales Man</option>
                                {dropdownSalesManOptions.map((category) => (
                                    <option key={category.Id} value={category.Id}>
                                        {category.Name}
                                    </option>
                                ))}
                            </select>

                        </div>

                    </div>
                    <div className="w-full mb-2 flex">

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TotalAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.TotalAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="TotalAmount"
                                    placeholder="TotalAmount"
                                    onChange={handleChange}
                                    readOnly
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Amt. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Discount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.DiscountAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.DiscountAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="DiscountAmount"
                                    placeholder="Discount Amount"
                                    onChange={handleChange}
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Disc. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Taxable</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TaxableAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.TaxableAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="TaxableAmount"
                                    placeholder="Taxable Amount"
                                    onChange={handleChange}
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Taxable. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Tax Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.TaxAmount || 0}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.TaxAmount > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name="TaxAmount"
                                    placeholder="TaxAmount"
                                    onChange={handleChange}
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Tax. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Round Off</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.RoundOff || 0}
                                    onChange={handleChange}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        //color: formData.RoundOff > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='RoundOff'

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* R.Off. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Total Amount</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.GrandTotal || 0}
                                    onChange={handleChange}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        //color: formData.RoundOff > 0 ? 'black' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='Grand Total'

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Total. */}
                                </span>
                            </div>

                        </div>
                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Cash</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CashAmount || 0}
                                    type="number"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    name="CashAmount"
                                    placeholder="Cash Amount"
                                    onChange={handleChange}
                                    max={Math.max(
                                        0,
                                        parseFloat(formData.GrandTotal || 0) -
                                        (parseFloat(formData.CardAmount || 0) + parseFloat(formData.UPIAmount || 0))
                                    )}
                                    min="0"
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* CASH . */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Card</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.CardAmount || 0}
                                    type="number"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    name="CardAmount"
                                    placeholder="CardAmount"
                                    onChange={handleChange}
                                    max={Math.max(
                                        0,
                                        parseFloat(formData.GrandTotal || 0) -
                                        (parseFloat(formData.CashAmount || 0) + parseFloat(formData.UPIAmount || 0))
                                    )}
                                    min="0"
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* CARD. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">UPI</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.UPIAmount || 0}
                                    onChange={handleChange}
                                    type="number"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        height: '32px',
                                    }}
                                    max={Math.max(
                                        0,
                                        parseFloat(formData.GrandTotal || 0) -
                                        (parseFloat(formData.CashAmount || 0) + parseFloat(formData.CardAmount || 0))
                                    )}
                                    name='UPIAmount'
                                    min="0"
                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* UPI. */}
                                </span>
                            </div>
                        </div>

                        <div className="w-1/4 mr-2">

                            <div className="w-full mr-2 relative" style={{ marginTop: '2px' }}>
                                <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="gstNumber">Balance</label>
                                <input
                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                    value={formData.BalanceAmount || 0}
                                    onChange={handleChange}
                                    type="text"
                                    style={{
                                        textAlign: 'right',
                                        fontWeight: 'bold',
                                        color: formData.BalanceAmount > 0 ? 'red' : 'inherit', // Highlight in red if DiscountAmount > 0                                      
                                        height: '32px',
                                    }}
                                    name='BalanceAmount'
                                    readOnly

                                />
                                <span
                                    style={{
                                        position: 'absolute',
                                        left: '10px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        color: 'gray',
                                        fontWeight: 'bold',
                                        fontSize: '12px',
                                    }}
                                >
                                    {/* Bal. */}
                                </span>
                            </div>
                        </div>

                    </div>

                    <div className="w-full mb-2 flex" style={{ marginTop: '-5px' }}>

                        <div className="w-3/5 mr-2" style={{ height: '30px' }}>
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="Weightage">
                                Item Name
                            </label>

                            <AsyncSelect
                                cacheOptions
                                loadOptions={fetchItemOptions}
                                onInputChange={handleItemChange}
                                onChange={handleChangeDrop}
                                value={selectedItemOption}
                                styles={{
                                    control: (base) => ({
                                        ...base,
                                        height: '35px',         // Adjust height
                                        minHeight: '35px',      // Ensure it doesn't shrink below this
                                        fontSize: '15px',       // Adjust font size
                                    }),
                                    input: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for input text
                                    }),
                                    singleValue: (base) => ({
                                        ...base,
                                        fontSize: '15px',       // Adjust font size for selected value
                                    }),
                                }}
                            />


                        </div>

                        <div className="w-3/5 mr-2" style={{ height: '30px' }}>
                            <label
                                className="block uppercase tracking-wide text-black text-xs font-bold mb-2"
                                htmlFor="Weightage"
                            >
                                Batch
                            </label>
                            <select
                                className={`custom-select ${selectedBatchOption ? 'fade-in' : 'fade-in'}`}
                                value={selectedBatchOption}
                                onChange={(e) => {
                                    const selectedValue = e.target.value;
                                    setSelectedBatchOption(selectedValue);

                                    setModalData({
                                        ...modalData,
                                        StockId: selectedValue,
                                        ItemId: batchOptions.find(x => x.StockId == selectedValue).ItemId,
                                        ItemName: batchOptions.find(x => x.StockId == selectedValue).ItemName,
                                        ItemName1: batchOptions.find(x => x.StockId == selectedValue).ItemName1,
                                        BalanceStock: batchOptions.find(x => x.StockId == selectedValue).BalanceStock,
                                        HSNCode: batchOptions.find(x => x.StockId == selectedValue).HSNCode,
                                        BatchNumber: batchOptions.find(x => x.StockId == selectedValue).BatchNumber,
                                        ExpirydDate: formatDateForInput(batchOptions.find(x => x.StockId == selectedValue).ExpirydDate),
                                        StockInDate: formatDateForInput(batchOptions.find(x => x.StockId == selectedValue).StockInDate),
                                        ManufacturingDate: formatDateForInput(batchOptions.find(x => x.StockId == selectedValue).ManufacturingDate),
                                        ExpiryDays: batchOptions.find(x => x.StockId == selectedValue).ExpiryDays,
                                        WholesaleRate: batchOptions.find(x => x.StockId == selectedValue).WholesaleRate,
                                        RetailRate: batchOptions.find(x => x.StockId == selectedValue).RetailRate,
                                        BtoCRate: batchOptions.find(x => x.StockId == selectedValue).BtoCRate,
                                        TaxRate: batchOptions.find(x => x.StockId == selectedValue).TaxRate,
                                    });
                                }}
                                style={{
                                    height: '35px', // Adjust height
                                    fontSize: '15px', // Adjust font size
                                }}
                            >
                                <option value="">Batch</option>
                                {batchOptions && batchOptions.map(category => (
                                    <option
                                        key={category.StockId}
                                        value={category.StockId}
                                        className="dropdown-option"
                                    >
                                        {category.BatchNumber +
                                            '| Exp.Date:' +
                                            formatDateForInput(category.ExpirydDate) +
                                            '| Bal:' +
                                            category.BalanceStock}
                                    </option>
                                ))}
                            </select>
                        </div>


                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Quantity
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="Quantity"
                                placeholder="Quantity"
                                value={modalData.Quantity}
                                // onChange={handleModalInputChange}
                                max={modalData.BalanceStock}
                                onChange={(e) => {
                                    const value = e.target.value === "" ? "" : parseFloat(e.target.value, 10);
                                    if (value === "" || value <= modalData.BalanceStock) {
                                        handleModalInputChange(e);
                                    }
                                }}
                                style={{ height: '35px' }}

                            />
                        </div>
                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Rate
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="Rate"
                                placeholder="Rate"
                                value={modalData.Rate}
                                onChange={handleModalInputChange}
                                style={{ height: '35px' }}
                                readOnly
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Net Weight
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="NetWeight"
                                placeholder="NetWeight"
                                value={modalData.NetWeight}
                                onChange={handleModalInputChange}
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="MinimumStock">
                                Gross Weight
                            </label>
                            <input
                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline  text-right"
                                type="number"
                                name="GrossWeight"
                                placeholder="GrossWeight"
                                value={modalData.GrossWeight}
                                onChange={handleModalInputChange}
                                style={{ height: '35px' }}
                            />
                        </div>

                        <div className="w-1/5 mr-2">
                            <button className="bg-grey-500  px-4 py-2 rounded" onClick={saveModalData}
                                style={{
                                    color: 'white',
                                    fontWeight: 'bolder',
                                    textTransform: 'none',
                                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.3)',
                                    maxHeight: '35px',
                                    //marginLeft: '5px',
                                    marginLeft: '6px',
                                    marginTop: '25px'
                                }}>
                                <span style={{ marginTop: '-15px', color: 'black' }}>+ ADD</span>
                            </button>
                        </div>


                        <div className="w-1/5 mr-2">
                            <input
                                className="shadow text-gray-700 leading-tight"
                                type="text"
                                placeholder="Search..."
                                value={searchQuery}
                                onChange={handleSearch}
                                onFocus={() => setIsFocused(true)}
                                onBlur={() => setIsFocused(false)}
                                style={{
                                    width: isFocused ? '200px' : '120px',
                                    height: '30px',
                                    border: '1px solid #ccc',
                                    borderRadius: '15px',
                                    padding: '0 20px',
                                    transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                                    outline: 'none',
                                    borderColor: isFocused ? 'darkcyan' : '#ccc',
                                    boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                                    marginTop: '30px'
                                }}
                            />
                        </div>

                    </div>
                </div>
            </div>
            <div className="w-full flex flex-wrap" style={{ backgroundColor: 'rgba(201, 222, 219, 0.5)', padding: '7px', borderRadius: '10px', marginTop: '-10px' }}>

                <div className="w-full mb-2" style={{ backgroundColor: '#c9dedb', marginTop: '-0.15%', overflow: 'auto' }}>
                    <table
                        className="min-w-full bg-white shadow-md rounded-lg overflow-hidden"
                        style={{ borderCollapse: 'collapse' }}
                    >
                        <thead className="bg-gray-100">
                            <tr>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>SL.No</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>ITEM NAME</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px' }}>BATCH</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>NW</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>GW</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'center' }}>QTY</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>RATE</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>AMOUNT</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS %</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>DIS ₹</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TAXABLE</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>GST ₹</th>
                                <th className="border-b" style={{ fontSize: '12px', color: '#01024E', padding: '3px', textAlign: 'right' }}>TOTAL</th>
                            </tr>
                        </thead>

                        <tbody>
                            {filteredData.map((item, index) => {


                                return (
                                    <tr key={index} className="border-b"
                                        style={{
                                            backgroundColor: index % 2 === 0 ? '#F7FAFF' : '#FFFFFF',
                                            borderBottom: '1px solid #E0E0E0',
                                            transition: 'transform 0.2s ease-in-out',
                                            cursor: 'pointer',
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                                    >
                                        <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '1px', textAlign: 'center', width: '65px' }}>
                                            {index + 1}
                                            <Tooltip
                                                title="Delete Sale"
                                                componentsProps={{
                                                    tooltip: {
                                                        sx: {
                                                            backgroundColor: 'darkolivegreen',
                                                            color: 'white',
                                                            border: '1px solid white',
                                                            fontWeight: 'bold',
                                                            boxShadow: 2,
                                                            fontSize: '0.875rem',
                                                        },
                                                    },
                                                }}
                                            >
                                                <DeleteIcon
                                                    style={{ color: 'brown', cursor: 'pointer', marginLeft: '20px', marginTop: '-5px' }}
                                                    onClick={() => openConfirmDialog(index)}
                                                />
                                            </Tooltip>
                                        </td>
                                        <td style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '150px' }}>{item.ItemName}</td>
                                        <td
                                            style={{ fontSize: '13px', fontWeight: 'bold', padding: '3px', width: '150px' }}
                                        >
                                            {`${item.BatchNumber} | Exp. Date: ${formatDateForInput(item.ExpirydDate)}`}
                                        </td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.NetWeight || 0}
                                                onChange={(e) => handleCalculation(e, index, 'NetWeight')}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FFCF96', textAlign: 'right' }}
                                                type="number"
                                                name="NetWeight"
                                                min={0}
                                            />
                                        </td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.GrossWeight || 0}
                                                onChange={(e) => handleCalculation(e, index, 'GrossWeight')}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D0F288', textAlign: 'right' }}
                                                type="number"
                                                name="GrossWeight"
                                                min={0}
                                            />
                                        </td>

                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                type="number"
                                                value={item.Quantity}
                                                className="w-full px-1 py-1 border rounded-md focus:outline-none focus:ring-2 focus:ring-yellow-400"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#FBF6E9', textAlign: 'right' }}
                                                min="0"
                                                aria-label={`Order quantity for item ${item.Id}`}
                                                name="Quantity"
                                                max={item.BalanceStock}
                                                onChange={(e) => {
                                                    const newValue = parseFloat(e.target.value, 10);
                                                    if (newValue <= item.BalanceStock) {
                                                        handleCalculation(e, index, 'Quantity');
                                                    }
                                                }}
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.Rate || 0}
                                                onChange={(e) => handleCalculation(e, index, 'Rate')}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#CBE4DE', textAlign: 'right' }}
                                                type="number"
                                                name="Rate"
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.Amount || 0}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                name="Amount"
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.DiscountPercentage || 0}
                                                onChange={(e) => handleCalculation(e, index, 'DiscountPercentage')}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#F6D6D6', textAlign: 'right' }}
                                                type="number"
                                                name="DiscountPercentage"
                                                min={0}
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.DiscountAmount || 0}
                                                readOnly
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.TaxableAmount || 0}
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', textAlign: 'right' }}
                                                readOnly
                                            />
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '70px' }}>
                                            <input
                                                value={parseFloat(item.TaxAmount)}
                                                className="px-1 py-1 border rounded-md"
                                                style={{
                                                    fontSize: '13px',
                                                    fontWeight: 'bold',
                                                    textAlign: 'right',
                                                    width: '70%', // Adjust the width to fit
                                                }}
                                                readOnly
                                            />
                                            <span style={{ marginLeft: '1px', color: 'darkmagenta', fontSize: '10px', fontWeight: 'bold' }}>
                                                {item.TaxRate ? parseFloat(item.TaxRate).toString() : 0}%
                                            </span>
                                        </td>
                                        <td style={{ padding: '3px', textAlign: 'right', width: '50px' }}>
                                            <input
                                                value={item.TotalAmount || 0}
                                                readOnly
                                                className="w-full px-1 py-1 border rounded-md"
                                                style={{ fontSize: '13px', fontWeight: 'bold', backgroundColor: '#D3F1DF', textAlign: 'right' }}
                                            />
                                        </td>

                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
            {showModal && (
                <Modal open={showModal} className={showModal ? 'notification-modal' : ''}>
                    <div className="fixed inset-0 flex items-start justify-center z-10 ">

                        <div className=" p-6 rounded-lg shadow-lg" style={{ width: '1000px', maxHeight: '80vh', overflowY: 'auto', overflowX: 'auto', marginTop: '50px', backgroundColor: '#FFFFFF' }}>
                            <div className="flex justify-end mt-2">
                                <button className="close-button md:static md:mr-2" onClick={closeDataModal} style={{ marginTop: '-10px', color: 'black' }}>
                                    <Tooltip title="Close">
                                        <FaTimes />
                                    </Tooltip>
                                </button>
                            </div>
                            <h6 style={{ textAlign: 'center', fontWeight: 'bold', color: '#B8001F' }}>EXPORT  DETAILS</h6>

                            <div className="w-full mb-2 flex" style={{ marginTop: '20px' }}>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                        Pre-Carriage By
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PreCarriageBy}
                                        type="text"
                                        placeholder="Pre-Carriage By"
                                        name='PreCarriageBy'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />
                                </div>
                                <div className="w-1/4 mr-2">

                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2" htmlFor="billNumber">
                                        Place of Receipts Pre-Carrier
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PlaceofReceiptsPreCarrier}
                                        type="text"
                                        placeholder="Place of Receipts Pre-Carrier"
                                        name='PlaceofReceiptsPreCarrier'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />
                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Vessel/FlightNo
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.VesselOrFlightNo}
                                        type="text"
                                        placeholder="Vessel / FlightNo"
                                        name='VesselOrFlightNo'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Port of Loading
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PortofLoading}
                                        type="text"
                                        placeholder="Port of Loading"
                                        name='PortofLoading'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>
                            </div>

                            <div className="w-full mb-2 flex" >

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Port of Discharge
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PortofDischarge}
                                        type="text"
                                        placeholder="Port of Discharge"
                                        name='PortofDischarge'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Place of Delivery
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.PlaceofDelivery}
                                        type="text"
                                        placeholder="Place of Delivery"
                                        name='PlaceofDelivery'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Country of Origin
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CountryofOrigin}
                                        type="text"
                                        placeholder="Country of Origin"
                                        name='CountryofOrigin'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Country of Destination
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.CountryofDestination}
                                        type="text"
                                        placeholder="Country of Destination"
                                        name='CountryofDestination'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                            </div>

                            <div className="w-full mb-2 flex" >

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        Marks & Nos
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.MarksandNos}
                                        type="text"
                                        placeholder="MarksandNos"
                                        name='MarksandNos'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        AD Code
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.ADCode}
                                        type="text"
                                        placeholder="AD Code"
                                        name='ADCode'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        LUT Number
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formData.LUTNumber}
                                        type="text"
                                        placeholder="LUT Number"
                                        name='LUTNumber'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                                <div className="w-1/4 mr-2">
                                    <label className="block uppercase tracking-wide text-black text-xs font-bold mb-2">
                                        LUT Date
                                    </label>
                                    <input className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:text-gray-600 focus:shadow-outline"
                                        value={formatDateForInput(formData.LUTDate)}
                                        type="date"
                                        placeholder="LUTDate"
                                        name='LUTDate'
                                        onChange={handleChange}
                                        maxLength={50}
                                        style={{ height: '32px', fontSize: '14px' }}
                                    />

                                </div>

                            </div>

                        </div>
                    </div>
                </Modal>
            )}
        </div>
    );
};

export default SaleEdit;
